/* loaded by smart-asset */
export default require("./assets/tote.i.svg")